module.exports = __webpack_public_path__ + "media/images/game_icon/th/VGGyumaoM-145bae9e485e1a8abbfae9dd54bc18e0.png";